import { Box, Typography } from '@mui/material';

interface ImageWithDescriptionProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

export default function InfoWithImage(props: ImageWithDescriptionProps) {
  const { icon, title, description } = props;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '250px',
        rowGap: 2,
        textAlign: 'left',
      }}
    >
      <Box
        sx={{
          width: '182px',
          height: '182px',
          borderRadius: '50%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: theme => theme.palette.text.secondary,
          marginBottom: '20px',
        }}
      >
        {icon}
      </Box>
      <Typography fontSize={'24px'} fontWeight={300} color={'text.primary'}>
        {title}
      </Typography>
      <Typography fontSize={'14px'} fontWeight={300} color={'text.primary'}>
        {description}
      </Typography>
    </Box>
  );
}
